import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

interface Dashboard2 {
    id?: number;
    length: number
    TotalUser: number;
    TotalSMSCampaign: number;
    TotalSMTPCampaign: number;
    TotalCompletedSMSCampaignList: number;
    totalMessages: number;
    smsCampaign?: Array<{ id: number; name: string; createdAt: string }>;
    smtpCampaign?: Array<{ id: number; name: string; subject: string; status: number; createdAt: string }>;
    smsChartData?: Array<{ label: string; Outbound: string; Inbound: string }>;
    smtpChartData?: Array<{ label: string; Outbound: number }>;
    pieChart?: Array<{ label: string; value: number }>;
    SMTPpieChart?: Array<{ label: string; value: number }>;
    campaign_id: number | null
}

interface Dashboard2State {
    dashboarddata2: Dashboard2 | null;
    error: string | null;
    loading: boolean;
}

export const GetallDashboard2Data = createAsyncThunk<
    Dashboard2,
    { from: string, to: string, campaign_type: string, campaign_id: number | null },
    { rejectValue: string }
>(
    'dashboard/fetchData',
    async ({ from, to, campaign_type, campaign_id }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`api/admin/v2/dashboard`, {
                params: { from, to, campaign_type, campaign_id },
            });
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message || "An error occurred");
        }
    }
);

const initialState: Dashboard2State = {
    dashboarddata2: null,
    error: null,
    loading: false,
};

const dashboard2Slice = createSlice({
    name: "dashboard2",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(GetallDashboard2Data.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetallDashboard2Data.fulfilled, (state, action: PayloadAction<Dashboard2>) => {
                state.loading = false;
                state.dashboarddata2 = action.payload;
            })
            .addCase(GetallDashboard2Data.rejected, (state, action: PayloadAction<string | undefined>) => {
                state.loading = false;
                state.error = action.payload || 'An error occurred';
            });
    },
});

export default dashboard2Slice.reducer;
